<template>
  <div>
    <div class="uk-section uk-section-small">
      <div class="uk-grid-small" uk-grid>
        <div class="uk-width-1-1">
          <h3>New Product - {{ product.name }}</h3>
        </div>
        <div class="uk-width-1-1">
          <div class="uk-grid-small" uk-grid>
            <div class="uk-width-1-1@s uk-width-1-1@m uk-width-1-2@l uk-width-1-2@l">
              <form class="uk-form-horizontal" v-on:submit.prevent="newProduct">
                <div class="uk-margin">
                  <div class="uk-inline">
                    <label for="name" class="uk-form-label">Name</label>
                    <div class="uk-form-controls">
                      <input id="name" type="text" class="uk-input" v-model="product.name" placeholder="Enter the name" required>
                    </div>
                  </div>
                </div>
                <div class="uk-margin">
                  <div class="uk-inline">
                    <label for="code" class="uk-form-label">Code</label>
                    <div class="uk-form-controls">
                      <input id="code" type="text" class="uk-input" v-model="product.code" placeholder="Enter the code" required>
                    </div>
                  </div>
                </div>
                <div class="uk-margin">
                  <div class="uk-inline">
                    <button class="uk-button uk-button-primary">Save</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "New",
    data() {
      return {
        product: {
          name: '',
          code: ''
        }
      }
    },
    methods: {
      newProduct() {
        const self = this;

        self.$request().post('/product', {
          name: self.product.name,
          code: self.product.code,
        }).then(r => {
          self.$uikit().notification({
            message: 'The product was successfully created.',
            status: 'success',
            position: 'top-right',
            timeout: 2500,
          });
          setTimeout(function(){
            self.$router.push({name: 'Product'});
          }, 2500);
        }).catch(e => {
          self.$uikit().notification({
            message: 'Something went wrong',
            status: 'warning',
            position: 'top-right',
            timeout: 5000,
          })
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/product/New.vue